'use client'

import React, { useContext, createContext, useState, useEffect, use, useRef } from 'react';
import { generateRandomPromotionCode, isWeekend } from '@/utils/UtilityScripts';
import { isTokenExpired } from '@/utils/LoggingScripts';
// import { useRouter } from 'next/navigation';
// import { usePathname } from 'next/navigation';
import { useRouter, usePathname } from '../navigation'
import { useLocale } from 'next-intl';
import { loadScript } from "@paypal/paypal-js";
import api from '@/axiosSetup';
import { canManageReservations } from '@/utils/reservationAccess.mjs';
import { canManageAdmins } from '@/utils/adminControlAccess.mjs';
const dotenv = require('dotenv'); 
dotenv.config();

const GlobalContext = createContext();

// DUMMY DATA

const _hotelUserObj = {
	_id: '65516eb7c18fc6b434b8afa4',
	promotionCode: 'IGKZH2RB6O4D',
	tier: -1,
	type: 'N/A',
	membershipCode: '323203212',
	firstName: 'GREY ROCK QUALITY HOTEL',
	lastName: '',
	userRole: 'Hotel',
	email: 'info@greyrockqualityinn.com',
	phoneNumber: '(506) 737-2000',
	allRooms: [],
}
const _eventsUserObj = {
	_id: '312121212s1afffa4',
	promotionCode: 'IGA2DKG12YDD5SZ',
	tier: -1,
	type: 'N/A',
	membershipCode: '592830185',
	firstName: 'EVENTS',
	lastName: '',
	email: 'events@greyrock-casino.com',
	phoneNumber: '',
	userRole: 'Events',
	allRooms: [],
}
const _gratUserObj = {
	_id: '312asddds4tf341afa4',
	promotionCode: 'IGA2DKG12YDD5SZ',
	tier: -1,
	type: 'N/A',
	membershipCode: '283960313',
	firstName: 'GREY ROCK ADVENTURE TOURS',
	lastName: '',
	email: 'info@greyrockadventuretours.com',
	phoneNumber: '800-573-5145',
	userRole: 'GRAT',
	allRooms: [],
}
const _casinoUserObj = {
	_id: '61123eb8c12fc5b434b8afa4',
	promotionCode: 'IGAZ15RVDEFZ',
	tier: -1,
	type: 'N/A',
	membershipCode: '193283745',
	firstName: 'GREY ROCK CASINO',
	lastName: '',
	email: 'info@greyrock-casino.com',
	phoneNumber: '(506) 735-2820',
	userRole: 'Casino',
	allRooms: [],
}
const _casinoOwnerUserObj = {
	_id: 'a1S532038112f]2c5bw3Xb84fa4',
	promotionCode: 'I9A34190X00X',
	tier: -1,
	type: 'N/A',
	membershipCode: '127835290',
	firstName: 'CASINO OWNER',
	lastName: '',
	email: 'johnbernard@rogers.com',
	phoneNumber: '(506) 740-7524',
	userRole: 'CasinoOwner',
	allRooms: [],
}

const _userNotFound = {
	_id: generateRandomPromotionCode(10),
	promotionCode: generateRandomPromotionCode(12),
	tier: -1,
	type: 'VIP',
	membershipCode: '-1',
	firstName: '',
	lastName: '',
	email: '',
	phoneNumber: '',
	userRole: 'VIP Client',
	allRooms: [],
	status: 'NOT_FOUND'
}

function GlobalContextProvider({ children }) {
	const [menuLoading, setMenuLoading] = useState(false);
	const [user, setUser] = useState(null);
	const [admin, setAdmin] = useState(null);
	const [isLoggingOut, setIsLoggingOut] = useState(false);
	const logoutInProgress = useRef(false);
	const [users, setUsers] = useState([]);
	const [days, setDays] = useState([]);
	const [newUsersBooked, setNewUsersBooked] = useState({
		newUsersBooked: [],
		activeDay: '',
	});
	const [activeDay, setActiveDay] = useState('');
	const [stretchDay, setStretchDay] = useState('');
	const [userCurrentRooms, setUserCurrentRooms] = useState([]); // YELLOW INIT ROOMS
	
	const [viewEventsMode, setViewEventsMode] = useState(false);
	const [viewClientsMode, setViewClientsMode] = useState(true); //explicitly for ADMINS
	const [activeDayObj, setActiveDayObj] = useState({}); //Works for ALL app (both events and user bookings)
	//Dummy Data
	const [hotelUserObj, setHotelUserObj] = useState(_hotelUserObj); //array of objects
	const [casinoUserObj, setCasinoUserObj] = useState(_casinoUserObj); //array of objects
	const [eventsUserObj, setEventsUserObj] = useState(_eventsUserObj); //array of objects
	const [GRATUserObj, setGRATUserObj] = useState(_gratUserObj); //array of objects
	const [casinoOwnerUserObj, setCasinoOwnerUserObj] = useState(_casinoOwnerUserObj); //array of objects
	const [userNotFound, setUserNotFound] = useState(_userNotFound); //array of objects
	// User Properties
	const [userRole, setUserRole] = useState('');
	//Hedged Dates
    const [membershipStartingDate, setMembershipStartingDate] = useState('');
    const [membershipExpiryDate, setMembershipExpiryDate] = useState('');
	//??? Keep?
	const [openEventUI, setOpenEventUI] = useState(false);
	//Editing/Deleting events
	const [editEventId, setEditEventId] = useState(-1);
	const [deleteEventId, setDeleteEventId] = useState(-1);
	const [eventMutable, setEventMutable] = useState({});
	//Viewing/Editing/Deleting users
	const [userMutable, setUserMutable] = useState({});
	const [viewUserModal, setViewUserModal] = useState(false);
	const [removeUserModal, setRemoveUserModal] = useState(false);
	const [isUserEditing, setIsUserEditing] = useState(false);
	const [usersBooked, setUsersBooked] = useState([]);

	const router = useRouter();
	const pathname = usePathname();
	// const [token, setToken] = useState('');
	//Loading - Calendar page 
    const [loading, setLoading] = useState(true);
    const [loadingBookings, setLoadingBookings] = useState(false);
    const [progress, setProgress] = useState(0);
	
	const [openBookingConfirmModal, setOpenBookingConfirmModal] = useState(false);
	const [openDeleteUserModal, setOpenDeleteUserModal] = useState(false);
	const [removeUserPendingDate, setRemoveUserPendingDate] = useState('');
	// Displaying user/special client bookings in PENDING HISTORY view mode
	const [userBookings, setUserBookings] = useState('');
	const [specialClientBookings, setSpecialClientBookings] = useState('');

	const [openHistory, setOpenHistory] = useState(false);
    const [historyOptions, setHistoryOptions] = useState('pending-days');
	//View booked users (in Calendar page)
	const [bookedUsers, setBookedUsers] = useState([]);
	//Historic Archiving
	const [historicDays, setHistoricDays] = useState([]);
	const [openUserHistoryPeriod, setOpenUserHistoryPeriod] = useState(false);
	//COUNTS
	const [specialClientBookedList, setSpecialClientBookedList] = useState([]);
	const [specialClientBookedCount, setSpecialClientBookedCount] = useState(0);
	//Checks if days are undefined (expired or no day exists)
	const [undefinedDay, setUndefinedDay] = useState(false);
	// Viewing Booked Period Days
	const [userBookingsPeriodArr, setUserBookingsPeriodArr] = useState([]);
	const [openDaysBooked, setOpenDaysBooked] = useState(false);
	// const [periodDays, setPeriodDays] = useState([]); //!!!!
	// Alert
	const [alertMessage, setAlertMessage] = useState('');
	const [alertModal, setAlertModal] = useState(false);
	// Login promotion codes
	const [period, setPeriod] = useState(Math.ceil((new Date().getMonth() + 1) / 2));
	const [year, setYear] = useState(new Date().getFullYear());
	// Earliest and Latest days
	const [earliestPeriodDay, setEarliestPeriodDay] = useState('');
	const [latestPeriodDay, setLatestPeriodDay] = useState('');
	// Admin control
	const [openViewAdmin, setOpenViewAdmin] = useState(false);
	const [openEditAdmin, setOpenEditAdmin] = useState(false);
	const [selectedAdmin, setSelectedAdmin] = useState({});
	//Meant for switching EventUIPanel other side
	const [otherSide, setOtherSide] = useState(false);
	const [pendingOtherSide, setPendingOtherSide] = useState(false);
	const [previousCalendarPos, setPreviousCalendarPos] = useState(false);
	// Meant for last div being problematic with possible dates
	const [userPeriodDays, setUserPeriodDays] = useState(false);
	const [disableStripeConfirmBtn, setDisableStripeConfirmBtn] = useState(false);
	//Selected person (mutable admin purposes)
	const [selectedPerson, setSelectedPerson] = useState(null);
	// Decide (for User) Stripe payment or free booking! (In context - public - was easier)
	const [openDecideClientBookingModal, setOpenDecideClientBookingModal] = useState(false);
	//Try?
	const [calendarDirection, setCalendarDirection] = useState('');
	const [addPopupUsers, setAddPopupUsers] = useState([]);
	//Guest/real client booking info
	const [realClientInfoObj, setRealClientInfoObj] = useState({
		notes: '',
	});
	const [clientGuestInfoObj, setClientGuestInfoObj] = useState({
		guestName: '',
		guestContact: '',
		guestReason: ''
	});
	const [bookedWithCard, setBookedWithCard] = useState(null);
	const [allSpecialClientBookings, setAllSpecialClientBookings] = useState([]);
	// new
	const [expiredUserBookings, setExpiredUserBookings] = useState([]);
	// new after cindy meeting with emily
	const [creditCardAdminEmailInfoObj, setCreditCardAdminEmailInfoObj] = useState(null);
	const [languageToggle, setLanguageToggle] = useState('EN');
	const locale = useLocale();
	//PayPal
	const [payPalSdkReady, setPayPalSdkReady] = useState(false);
	const [paypal, setPaypal] = useState(null);
	//Action Loader
	const [actionLoader, setActionLoader] = useState(false);
	// Pick 2 dates in between for special clients
	const [selectedRange, setSelectedRange] = useState({ startDate: 'null', endDate: 'null' });
	const [applyMultiDates, setApplyMultiDates] = useState(false);
	// Payment in progress indicator
	const [paymentInProgress, setPaymentInProgress] = useState(false);
	const [persistentUserActiveDates, setPersistentUserActiveDates] = useState(false);
	const [failureModal, setFailureModal] = useState(false);
	// Open via popup
	const [openViaTablePopup, setOpenViaTablePopup] = useState(false);
	const [inspectDate, setInspectDate] = useState(''); //either opens from EventsUI, or popup tables
	const [initialEditMode, setInitialEditMode] = useState(true); //either opens from EventsUI, or popup tables
	const [currentMonth, setCurrentMonth]  = useState(new Date().getMonth()); //10
    const [currentYear, setCurrentYear]  = useState(new Date().getFullYear()); 
	// REALLY NEW!!! 
	const [SCActiveDates, setSCActiveDates] = useState([]); // Special Clients
	const [activeDates, setActiveDates] = useState([]); // Clients
	const [multipleSpecialClientBookings, setMultipleSpecialClientBookings] = useState(1);
	// Viewing user valid spots in Calendar (viewEventsMode === true) ALL NEW
	const [userViewSpots, setUserViewSpots] = useState(null);
	const [openStripeModalAdmin, setOpenStripeModalAdmin] = useState(false);
	const [addUserConfirmModal, setAddUserConfirmModal] = useState(false);
	const [openAddUserTable, setOpenAddUserTable] = useState(false);
	const [clientNotesModal, setClientNotesModal] = useState(false);
	const [openViewUsers, setOpenViewUsers] = useState(false);

	// Both logout buttons share the calendar's cleanup and navigation behavior.
	const logout = async () => {
		if (logoutInProgress.current) return;
		logoutInProgress.current = true;
		setIsLoggingOut(true);
		try {
			await api.post('/api/logout');
		} catch (error) {
			console.error('Logout error:', error);
		} finally {
			setUser(null);
			setAdmin(null);
			setActiveDates([]);
			setUserCurrentRooms([]);
			document.querySelectorAll('.day').forEach(day => {
				day.classList.remove('active', 'occupied', 'booked', 'valid-day', 'yellow');
			});
			router.replace('/');
		}
	};

	useEffect(() => {
        if (process.env.NEXT_PUBLIC_NODE_ENV == 'production') {
            console.log = console.warn = console.error = () => {};
        }
    }, []);

    // useEffect(() => {
	// 	if (pathname !== '/') {
	// 		//checks to see if user is logged in from localStorage
	// 		const _token = localStorage.getItem('token');
	// 		if (_token !== null) {
	// 			getUserFromToken(_token);
	// 		} else {
	// 			router.push('/');
	// 		}
			
	// 		if (isTokenExpired(_token)) {
	// 			router.push('/');
	// 		}
	// 	}
	// 	setRemoveUserModal(false);
	// 	setApplyMultiDates(false);
    // }, [pathname])

	// const getUserFromToken = async (token) => {
	// 	try {
	// 	   const response = await api.post(`/api/verify`, { token });
	// 	   if (response.data.user) {
	// 		   setUser(response.data.user);
	// 		   kickOutUsers(response.data.user);
	// 		//    console.log('VERIFIED!', response.data.year);
	// 		//    console.log('VERIFIED!', response.data.period);
	// 		   	setPeriod(response.data.period);
	// 			 setYear(response.data.year);
	// 			}
	// 		if (response.data.admin) {
	// 			setAdmin(response.data.admin);
	// 			// console.log('VERIFIED!', response.data.year);
	// 			// console.log('VERIFIED!', response.data.period);
	// 			setPeriod(response.data.period);
	// 			setYear(response.data.year);
	// 		}
	// 		kickOutNonAdmins(response.data.admin);
	// 	} catch (error) {
	// 		router.push('/');
	// 		setUser(null);
	// 		setAdmin(null);
	// 		console.log('Login Error', error);
	// 	}
	//   }

  // NEW COOKIE WAY
	useEffect(() => {
    let cancelled = false;

    const guard = async () => {
      if (pathname === "/") {
        logoutInProgress.current = false;
        setIsLoggingOut(false);
        setRemoveUserModal(false);
        setApplyMultiDates(false);
        return; // public page
      }
      if (logoutInProgress.current) return;

      try {
        const { data } = await api.get("/api/verify"); // reads httpOnly cookie
		
        if (cancelled || logoutInProgress.current) return;

        if (data.user) {
          setUser(data.user);
          kickOutUsers(data.user);
        } else {
          setUser(null);
        }

        if (data.admin) {
          setAdmin(data.admin);
        } else {
          setAdmin(null);
        }

        if (data.period != null && data.year != null) {
          setPeriod(data.period);
          setYear(data.year);
        }

        kickOutNonAdmins(data.admin);
      } catch (err) {
        if (cancelled || logoutInProgress.current) return;
        setUser(null);
        setAdmin(null);
        router.push("/");
      } finally {
        if (!cancelled && !logoutInProgress.current) {
          setRemoveUserModal(false);
          setApplyMultiDates(false);
        }
      }
    };
    guard();
    return () => {
      cancelled = true;
    };
  }, [pathname]);

	  const kickOutUsers = (_user) => {
		if (pathname.startsWith("/admin/")) {
			if (_user) {
				router.push('/access-denied');
			}
		}
	}
	 
	const kickOutNonAdmins = (_admin) => {
		if (pathname.replace(/\/$/, '') === '/admin/admin-control' && !canManageAdmins(_admin)) {
			router.replace('/access-denied');
			return;
		}
		const isAdminHotel = _admin && _admin.adminRole === 'hotel';
		const isAdminEvents = _admin && _admin.adminRole === 'events';
		const isAdminGRAT = _admin && _admin.adminRole === 'grat';
		const isAdminCasino = _admin && _admin.adminRole === 'casino';
		const isCasinoClientPage = pathname === '/admin/add-client' || pathname === '/admin/view-clients';
		const isRecordsPage = pathname === '/admin/view-records';
		const isReservationsPage = pathname.replace(/\/$/, '') === '/admin/reservations';
		if (isReservationsPage) {
			if (!canManageReservations(_admin)) router.replace('/access-denied');
			return;
		}
	  
		if ((pathname.startsWith("/admin/") && (isAdminHotel || isAdminEvents || isAdminGRAT)) || (pathname.startsWith("/admin/") && isAdminCasino && !isCasinoClientPage)) {
		   //Hotel exception for FINANCE and GMGRH
		    if (isAdminHotel && _admin.viewRecords == true && isRecordsPage) return;
			router.push('/access-denied');
		}
	  }

	return (
		//NEEDED {{ }}
		<GlobalContext.Provider value={{isLoggingOut, logout, membershipStartingDate, membershipExpiryDate, user, setUser, admin, setAdmin, userRole, setUserRole, activeDay, setActiveDay, viewEventsMode, setViewEventsMode, openEventUI, setOpenEventUI, editEventId, setEditEventId, deleteEventId, setDeleteEventId, viewClientsMode, setViewClientsMode, days, setDays, eventMutable, setEventMutable, userMutable, setUserMutable, viewUserModal, setViewUserModal, isUserEditing, setIsUserEditing, userCurrentRooms, setUserCurrentRooms, activeDayObj, setActiveDayObj, removeUserModal, setRemoveUserModal, loading, setLoading, progress, setProgress, openBookingConfirmModal, setOpenBookingConfirmModal, usersBooked, setUsersBooked, openDeleteUserModal, setOpenDeleteUserModal, users, setUsers, removeUserPendingDate, setRemoveUserPendingDate, casinoUserObj, setCasinoUserObj, hotelUserObj, setHotelUserObj, casinoOwnerUserObj, setCasinoOwnerUserObj, newUsersBooked, setNewUsersBooked, specialClientBookings, setSpecialClientBookings, userBookings, setUserBookings, loadingBookings, setLoadingBookings, bookedUsers, setBookedUsers, openHistory, setOpenHistory, historyOptions, setHistoryOptions, historicDays, setHistoricDays, openUserHistoryPeriod, setOpenUserHistoryPeriod, specialClientBookedCount, setSpecialClientBookedCount, undefinedDay, setUndefinedDay, specialClientBookedList, setSpecialClientBookedList, userNotFound, setUserNotFound, openDaysBooked, setOpenDaysBooked, userBookingsPeriodArr, setUserBookingsPeriodArr, alertMessage, setAlertMessage, alertModal, setAlertModal, period, setPeriod, year, setYear, earliestPeriodDay, setEarliestPeriodDay, latestPeriodDay, setLatestPeriodDay, openViewAdmin, setOpenViewAdmin, openEditAdmin, setOpenEditAdmin, selectedAdmin, setSelectedAdmin, otherSide, setOtherSide, previousCalendarPos, setPreviousCalendarPos, pendingOtherSide, setPendingOtherSide, userPeriodDays, setUserPeriodDays, disableStripeConfirmBtn, setDisableStripeConfirmBtn, selectedPerson, setSelectedPerson, openDecideClientBookingModal, setOpenDecideClientBookingModal,   calendarDirection, setCalendarDirection, addPopupUsers, setAddPopupUsers, menuLoading, setMenuLoading, clientGuestInfoObj, setClientGuestInfoObj, bookedWithCard, setBookedWithCard, allSpecialClientBookings, setAllSpecialClientBookings, expiredUserBookings, setExpiredUserBookings, creditCardAdminEmailInfoObj, setCreditCardAdminEmailInfoObj, languageToggle, setLanguageToggle, eventsUserObj, setEventsUserObj, GRATUserObj, setGRATUserObj, payPalSdkReady, setPayPalSdkReady, paypal, setPaypal, actionLoader, setActionLoader, applyMultiDates, setApplyMultiDates, selectedRange, setSelectedRange, stretchDay, setStretchDay, paymentInProgress, setPaymentInProgress, persistentUserActiveDates, setPersistentUserActiveDates, failureModal, setFailureModal, realClientInfoObj, setRealClientInfoObj, openViaTablePopup, setOpenViaTablePopup, inspectDate, setInspectDate, initialEditMode, setInitialEditMode, currentMonth, setCurrentMonth, currentYear, setCurrentYear, multipleSpecialClientBookings, setMultipleSpecialClientBookings, userViewSpots, setUserViewSpots, openStripeModalAdmin, setOpenStripeModalAdmin, addUserConfirmModal, setAddUserConfirmModal, openAddUserTable, setOpenAddUserTable, clientNotesModal, setClientNotesModal, activeDates, setActiveDates, SCActiveDates, setSCActiveDates, openViewUsers, setOpenViewUsers }}
		> 
			{children}
		</GlobalContext.Provider>
	);
}

const useGlobalContext = () => {
	const context = useContext(GlobalContext);
	if (!context) throw new Error('Issue with provider');
	return context;
};

export { GlobalContextProvider, useGlobalContext };
